import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var max = Math.max;
var rgb2cmyk = function rgb2cmyk() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _slicedToArray(_unpack, 3),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2];
  r = r / 255;
  g = g / 255;
  b = b / 255;
  var k = 1 - max(r, max(g, b));
  var f = k < 1 ? 1 / (1 - k) : 0;
  var c = (1 - r - k) * f;
  var m = (1 - g - k) * f;
  var y = (1 - b - k) * f;
  return [c, m, y, k];
};
export default rgb2cmyk;